import { addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "./firebase";

const COLLECTION_NAME = "strengthExerciseLibrary";

const cleanExercise = (exercise = {}) => ({
    name: exercise.name || "",
    category: exercise.category || "",
    primaryMuscles: exercise.primaryMuscles || [],
    secondaryMuscles: exercise.secondaryMuscles || [],
    equipment: exercise.equipment || [],
    difficulty: exercise.difficulty || "Iniciante",
    instructions: exercise.instructions || "",
    videoUrl: exercise.videoUrl || "",
    imageUrl: exercise.imageUrl || "",
    alternatives: exercise.alternatives || [],
    tags: exercise.tags || [],
});

const StrengthExerciseLibraryService = {
    getAll: async (idTenant) => {
        if (!idTenant) return [];

        const q = query(
            collection(db, "tenants", idTenant, COLLECTION_NAME),
            orderBy("createdAt", "desc")
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, source: "tenant", ...doc.data() }));
    },

    save: async ({ idTenant, authUser, name, category, exercise }) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");
        if (!name?.trim()) throw new Error("Nome do exercício é obrigatório.");

        const payload = {
            name: name.trim(),
            category: category || "Personalizado",
            exercise: cleanExercise(exercise),
            createdAt: serverTimestamp(),
            createdBy: {
                uid: authUser?.uid || "system",
                name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema",
            },
        };

        const docRef = await addDoc(collection(db, "tenants", idTenant, COLLECTION_NAME), payload);
        return { id: docRef.id, source: "tenant", ...payload };
    },

    update: async ({ idTenant, exerciseId, name, category, exercise }) => {
        if (!idTenant || !exerciseId) throw new Error("Tenant e Exercício IDs são obrigatórios.");
        if (!name?.trim()) throw new Error("Nome do exercício é obrigatório.");

        const payload = {
            name: name.trim(),
            category: category || "Personalizado",
            exercise: cleanExercise({
                ...exercise,
                name: name.trim(),
                category: category || "Personalizado",
            }),
            updatedAt: serverTimestamp(),
        };

        await updateDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, exerciseId), payload);
        return { id: exerciseId, source: "tenant", ...payload };
    },

    rename: async ({ idTenant, exerciseId, name, category }) => {
        return StrengthExerciseLibraryService.update({
            idTenant,
            exerciseId,
            name,
            category,
            exercise: { name, category },
        });
    },

    delete: async ({ idTenant, exerciseId }) => {
        if (!idTenant || !exerciseId) throw new Error("Tenant e Exercício IDs são obrigatórios.");
        await deleteDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, exerciseId));
        return true;
    },
};

export default StrengthExerciseLibraryService;
